import { useEffect, useState } from 'react';
import { NmibleService } from '@/services';
export const useNmibleStatus = ({ enabled }) => {
    const [nmibleStatus, setNmibleStatus] = useState(null);
    const [nmibleLoading, setNmibleLoading] = useState(enabled);
    useEffect(() => {
        if (!enabled) {
            setNmibleLoading(false);
            return;
        }
        let cancelled = false;
        setNmibleLoading(true);
        NmibleService.getStatus()
            .then((result) => {
            if (!cancelled) {
                setNmibleStatus(result);
                setNmibleLoading(false);
            }
        })
            .catch(() => {
            // Non-200: participant is not eligible, keep default state
            if (!cancelled)
                setNmibleLoading(false);
        });
        return () => {
            cancelled = true;
        };
    }, [enabled]);
    return {
        nmibleLoading,
        nmibleStatus
    };
};
